module.exports = __webpack_public_path__ + "img/pharmacare-black.fccaa0b6.png";